import { containerStyle } from '../../styles';

export default {
  container: {
    ...containerStyle
  }
};
